module.exports = __webpack_public_path__ + "static/media/report_communication.3f4cce26.svg";